import styled from "styled-components";
import TextAction from "@streeteasy/design-system/text-action";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Wrapper = styled.div`
  color: inherit;

  @media screen and (max-width: ${largeScreen}px) {
    padding: 8px 14px 8px 31px;
  }
`;

export const Icon = styled.img.attrs({
  "aria-hidden": true
})`
  height: 42px;
  margin: 0 5px 0 0;
  overflow: hidden;
  text-indent: 100%;
  width: 137px;
`;

export const Link = styled(TextAction).attrs({ target: "_blank" })`
  display: block;
  text-decoration: none !important;

  &:active,
  &:focus,
  &:hover {
    background-color: inherit;
    color: inherit;
    text-decoration: none !important;
  }

  @media screen and (max-width: ${largeScreen}px) {
    margin: 10px 0 27px;
  }
`;
